import { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Components
import { LoadingCards } from 'components';
import { ProfileOnBoarding } from './OnBoarding';
import { Transcript } from './Transcript';
import { RecentCme } from './RecentCme';

// Store
import {
  userProfileFullNameSelector,
  userProfileHasCompletedWizardSelector,
  userProfileRecentCMELoadingSelector,
  userProfileRecentCMESelector,
  userProfileSelector,
} from 'store/profile/selectors';
import { getUserProfileRecentCME } from 'store/profile/actions';

// Core
import { IUserProfile, useAppDispatch } from 'core';

// Styles
import styles from './Profile.module.scss';

export const Profile = (): ReactElement => {
  // Selectors
  const userProfile: IUserProfile = useSelector(userProfileSelector);
  const fullName: string = useSelector(userProfileFullNameSelector);
  const hasCompletedWizard: boolean = useSelector(userProfileHasCompletedWizardSelector);

  const dispatch = useAppDispatch();
  const isLoadingRecentCME = useSelector(userProfileRecentCMELoadingSelector);
  const recentCme = useSelector(userProfileRecentCMESelector);

  useEffect(() => {
    dispatch(getUserProfileRecentCME());
  }, [dispatch]);

  // Show this while loading.
  if (!userProfile) return <LoadingCards />;

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        Welcome {fullName}!
        <div className={styles.caption}>
          {isLoadingRecentCME || recentCme?.results?.length !== 0 ? (
            <>To receive the most accurate data about your CME, please complete or confirm the following.</>
          ) : (
            <>
              <div>
                You currently do not have any CME credits to display. Please verify that your licensing information is
                accurate, as any missing credits may be related to incorrect or incomplete details.
              </div>
            </>
          )}
        </div>
      </h1>
      {!hasCompletedWizard && <ProfileOnBoarding />}
      <Transcript />
      <RecentCme />
    </div>
  );
};
